// src/firebase.ts
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
  Messaging,
  MessagePayload
} from "firebase/messaging";

// Your Web Push certificate public key
const VAPID_KEY =
  "BIrPSTy30iNyhHuQSNAPLoZIIYpPoCO26TF0FNhgqkc5feAuvvp-xUqkhFPk3gcmEQTz0qY9U0bNWSIb6ZF_sBQ";

/*
 Replace these values with your Firebase project config
 (Firebase Console -> Project settings -> General -> Your apps)
*/
const firebaseConfig = {
    apiKey: "AIzaSyAB446AjOfYVvc6aTtT3VODtDYjjqEQUHY",
    authDomain: "prod-parceltracer.firebaseapp.com",
    projectId: "prod-parceltracer",
    storageBucket: "prod-parceltracer.firebasestorage.app",
    messagingSenderId: "36728232376",
    appId: "1:36728232376:web:ea48e038649369a9f7d74d",
    measurementId: "G-YPNBR877XY"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging: Messaging = getMessaging(app);


export async function registerServiceWorkerAndGetToken() {
  if (!("serviceWorker" in navigator)) {
    console.warn("Service workers are not supported in this browser.");
    return null;
  }

  try {

    let registration
    // Register (or get existing) service worker
    if (navigator.serviceWorker.controller) {
      registration = await navigator.serviceWorker.ready; // use existing SW
    } else {
      registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    }
    
    // Ask for permission if needed
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission not granted:", permission);
      return null;
    }

    // ✅ Reuse cached token if available
    const cachedToken = localStorage.getItem("fcm_token");
    if (cachedToken) {
      console.log("Using cached FCM token:", cachedToken);
      return { token: cachedToken, registration };
    }

    // 🚀 Only get new token if none cached
    const newToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (newToken) {
      console.log("Got new FCM token:", newToken);
      localStorage.setItem("fcm_token", newToken);
      return { token: newToken, registration };
    } else {
      console.warn("No FCM token available.");
      return null;
    }
  } catch (err) {
    console.error("Failed to register SW or get token:", err);
    return null;
  }
}



/**
 * Handle foreground messages (app open).
 * @param callback - receives the FCM payload
 */
export function onForegroundMessage(
  callback: (payload: MessagePayload) => void
): void {
  onMessage(messaging, (payload: MessagePayload) => {
    console.log("A message was received")
    callback(payload);
  });
}
  
/**
 * Remove token locally (use on logout) and notify your backend.
 */
export async function removeFcmToken(): Promise<boolean> {
  try {
    const result = await deleteToken(messaging);
    console.log(result)
    return result; // true if successful
  } catch (err) {
    console.error("Failed to delete token:", err);
    return false;
  }
}
